import actions from './actions'
import getters from './getters'
import mutations from './mutations'


const state = {
  measurementTypesInfo: [
    { id: 1, measurementGroupId: 2, slug: 'blood_pressure', iconName: 'blood_pressure' },
    { id: 2, measurementGroupId: 3, slug: 'temperature', iconName: 'temperature' },
    { id: 3, measurementGroupId: 4, slug: 'glucose', iconName: 'glucose' },
    { id: 4, measurementGroupId: 5, slug: 'body_composition', iconName: 'body_composition' },
    { id: 5, measurementGroupId: 11, slug: 'spirometry', iconName: 'spirometry' },
    { id: 6, measurementGroupId: 18, slug: 'oximetry', iconName: 'oximetry' },
    { id: 7, measurementGroupId: 20, slug: 'mapa_24', iconName: 'mapa24' },
    { id: 8, measurementGroupId: 6000, slug: 'frailty_phenotype', iconName: 'frailty_phenotype' },
    { id: 9, measurementGroupId: 6001, slug: 'sarcopenia', iconName: 'sarcopenia' },
    { id: 10, measurementGroupId: 9000, slug: 'audiology', iconName: 'audiology' },
    { id: 11, measurementGroupId: 9050, slug: 'optometry', iconName: 'optometry' },
    { id: 12, measurementGroupId: 10000, slug: 'colesterol', iconName: 'colesterol' },
  ],

}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
